import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

export const IMMONET_URLS = {
  houseDetail: (houseSlug: string, vendorSlug: string) =>
    `/dienstleister/hausideen/${vendorSlug}/${houseSlug}/` as const,
  vendorDetail: (vendorSlug: string) =>
    `/dienstleister/${vendorSlug}/hausbau/` as const,
  vendorOffices: (vendorSlug: string) =>
    `/dienstleister/${vendorSlug}/alle-standorte/` as const,
  vendorOffice: (vendorSlug: string, officeSlug: string) =>
    `/dienstleister/musterhaeuser/${vendorSlug}/${officeSlug}/` as const,
  houseList: () => `/hausbau-suche/liste/` as const,
  vendorList: () => `/service/hausanbieter/` as const,
  userAccount: (magicToken?: string) => getUserAccountUrl(magicToken),
  houseQuiz: () => `/bestellungen/kataloge/` as const,
  financeQuiz: () => `/bestellungen/finanzierungsberatung/` as const,
  dataServiceLeadAssignment: () => `data-services/lead-assignment` as const,
  financeAssistance: () => `/bestellungen/finanzierungs-assistent/` as const,
  budgetCalculator: () => `/bestellungen/finanzierungs-assistent/` as const,
  vendorMap: () => '/dienstleister/karte/' as const,
  privacyPolicy: () => `/datenschutz` as const
} as const

export type URLDictionary = keyof typeof IMMONET_URLS

export function getUrl(key: URLDictionary): $TSFixMe {
  return IMMONET_URLS[key]
}

if (typeof window !== 'undefined' && window.__DOMAIN__ === 'immonet') {
  window.getUrl = getUrl
}

const getUserAccountUrl = (magicToken?: string) => {
  const getUrlWithMagicToken = (mt: string) =>
    `mein-konto/ml/${mt}/?r=/mein-konto/`

  const baseUrlByEnv = {
    production: 'https://www.bauen.de/',
    staging: 'https://staging.bauen.de/',
    'testing-1': 'http://testing-1.bauen.de:8081/',
    'testing-2': 'http://testing-2.bauen.de:8082/',
    'testing-3': 'http://testing-3.bauen.de:8083/',
    local: 'http://bauen.localhost:8000/'
  }[DEPLOY_ENV]

  return magicToken
    ? `${baseUrlByEnv}${getUrlWithMagicToken(magicToken)}`
    : `${baseUrlByEnv}mein-konto/`
}
